import { EngineBuilder } from '~/Scene/Viewer/engineBuilder';
import { SystemLayer } from '~/Scene/System/systemLayer';
import { MouseCatcher } from '~/Scene/Catchers/mouseCatcher';
import { SceneryEvironment } from '~/Scene/Scenery/sceneryEnvironment';
import { SceneryPipeline } from '~/Scene/Scenery/sceneryPipeline';
import { ContentsManager } from '~/Scene/Content/contentsManager';
import { SceneryCamera } from '~/Scene/Scenery/sceneryCamera';
import { PointofviewsManager } from '~/Scene/Pointofview/pointofviewsManager';
import { RenderQuality } from '~/Scene/System/systemQuality';
import { CanvasGridPlane } from '~/Services/Studio/Canvas/canvasGridPlane';
import { UiDragAnimation } from '~/Scene/Ui/uiDragAnimation';
import { UiCameraRotate } from '~/Scene/Ui/uiCameraRotate';
import { MaterialEvent } from '~/Scene/Tool/toolMaterial';

// Random Element just to start engine
export const container = document.body.children[0] as HTMLElement;
// @ts-ignore
export const _engine = new EngineBuilder({ container });
const { sceneContainer } = _engine;
export const _system = new SystemLayer(_engine.canvas as HTMLCanvasElement);
const { toolMaterial } = _system;
_system.setNeedProcess(false);
_system.setLimitFPS(true);
_system.setQuality(RenderQuality.High);

export const _mouseCatcher = new MouseCatcher(_system);
export const _contentsManager = new ContentsManager(_system, _mouseCatcher);
export const _environment = new SceneryEvironment(_system);
export const _pipeline = new SceneryPipeline(_system);
export const _camera = new SceneryCamera(_system, _mouseCatcher);
export const _pointofviewsManager = new PointofviewsManager();

export const _uiDragAnimation = new UiDragAnimation(
    _system,
    sceneContainer,
    _camera
);
export const _uiCameraRotate = new UiCameraRotate(_system);
export const canvasGridPlane = new CanvasGridPlane(_system);

export function disposeProject(): void {
    // _contentsManager.destroyContents();
    _system.pauseRender();
}

// EVENTS
document.addEventListener('mouseleave', () => {
    _system.pauseRender();
});
document.addEventListener('mouseenter', () => {
    _system.startRender();
});
document.addEventListener('focus', () => {
    _system.startRender();
});

toolMaterial.on(MaterialEvent.RemoveFromAll, (materialOptions) => {
    const models = _contentsManager.getContentModels();
    models.forEach((model) => {
        model.removeMaterialFromVariants(materialOptions.key);
    });
});
